import script from "./Startup_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Startup_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Startup_Items.vue?vue&type=style&index=0&id=a2cf86d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2cf86d4"]])

export default __exports__